/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Control_CenterInputs */

const en_gift_control_center = /** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gift Control Center`)
};

const es_gift_control_center = /** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de Control de Regalos`)
};

const fr_gift_control_center = /** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de contrôle des cadeaux`)
};

const de_gift_control_center = /** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschenkkontrollzentrum`)
};

const id_gift_control_center = /** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Kontrol Hadiah`)
};

/** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */
const ja_gift_control_center = en_gift_control_center;

/** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */
const zh_gift_control_center = en_gift_control_center;

/** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */
const ar_gift_control_center = en_gift_control_center;

/** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */
const it_gift_control_center = en_gift_control_center;

/** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */
const ru_gift_control_center = en_gift_control_center;

/** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */
const pt_gift_control_center = en_gift_control_center;

/** @type {(inputs: Gift_Control_CenterInputs) => LocalizedString} */
const ko_gift_control_center = en_gift_control_center;

/**
* | output |
* | --- |
* | "Gift Control Center" |
*
* @param {Gift_Control_CenterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_control_center = /** @type {((inputs?: Gift_Control_CenterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Control_CenterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_control_center(inputs)
	if (locale === "es") return es_gift_control_center(inputs)
	if (locale === "fr") return fr_gift_control_center(inputs)
	if (locale === "de") return de_gift_control_center(inputs)
	if (locale === "ja") return ja_gift_control_center(inputs)
	if (locale === "zh") return zh_gift_control_center(inputs)
	if (locale === "ar") return ar_gift_control_center(inputs)
	if (locale === "id") return id_gift_control_center(inputs)
	if (locale === "it") return it_gift_control_center(inputs)
	if (locale === "ru") return ru_gift_control_center(inputs)
	if (locale === "pt") return pt_gift_control_center(inputs)
	return ko_gift_control_center(inputs)
});